const anchorLinks = document.querySelectorAll('.smooth-scroll');

if (anchorLinks) {
  anchorLinks.forEach(item => {

    item.addEventListener('click', e => {
      const hashVal = item.getAttribute('href');
      const target = document.querySelector(hashVal);

      scrollIntoView(target, {
        block: 'start',
        inline: 'nearest'
      });
      window.history.pushState(null, null, hashVal);
      e.preventDefault();
    });
  });
}

const anchorLinksFromStickyCta = document.querySelectorAll('.smooth-scroll--with-sticky-cta');

if (anchorLinksFromStickyCta) {
  anchorLinksFromStickyCta.forEach(item => {

    item.addEventListener('click', e => {

      if (document.getElementById("group-claims-content") != null && document.getElementById("group-claims-content").classList.contains('s-tabs-section-wrapper--is-sticky')) {
        const hashVal = item.getAttribute('href');
        const target = document.getElementById("s-tabs-section-placeholder");

        scrollIntoView(target, {
          block: 'start',
          inline: 'nearest'
        });
        window.history.pushState(null, null, hashVal);
      }

    });
  });
}
